import { render, staticRenderFns } from "./UserDeletion.vue?vue&type=template&id=9c3e7c94&scoped=true&"
import script from "./UserDeletion.vue?vue&type=script&lang=js&"
export * from "./UserDeletion.vue?vue&type=script&lang=js&"
import style0 from "./UserDeletion.vue?vue&type=style&index=0&id=9c3e7c94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3e7c94",
  null
  
)

export default component.exports